import React from "react";

const EpisodePageSkeleton = () => {
  return (
    <section className="bg-black min-h-screen">
      {/* Hero Section Skeleton */}
      <div className="relative w-full h-[auto] min-h-[50vh] md:h-[70vh] overflow-hidden pt-16 md:pt-0">
        <div className="absolute inset-0 bg-gradient-to-br from-gray/40 to-gray/20"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-black/30" />
        
        {/* Content Overlay Skeleton */}
        <div className="relative z-10 h-full flex items-center md:items-end padding py-8 md:pb-12">
          <div className="w-full max-w-7xl mx-auto space-y-4">
            {/* TV Show Title Skeleton */}
            <div className="h-8 md:h-10 bg-gray/30 rounded-lg w-1/2 backdrop-blur-sm overflow-hidden relative">
              <div className="absolute inset-0 bg-gradient-to-r from-gray/30 via-white/10 to-gray/30 animate-shimmer"></div>
            </div>
            
            {/* Episode Image and Info Skeleton */}
            <div className="flex flex-col md:flex-row gap-4 items-start md:items-center">
              <div className="w-full md:w-64 aspect-video rounded-lg bg-gray/30 backdrop-blur-sm overflow-hidden relative">
                <div className="absolute inset-0 bg-gradient-to-r from-gray/40 via-white/10 to-gray/40 animate-shimmer"></div>
              </div>
              
              <div className="flex-1 space-y-3">
                <div className="h-6 bg-gray/30 rounded w-3/4 backdrop-blur-sm overflow-hidden relative">
                  <div className="absolute inset-0 bg-gradient-to-r from-gray/30 via-white/10 to-gray/30 animate-shimmer"></div>
                </div>
                <div className="h-5 bg-gray/20 rounded w-1/2 backdrop-blur-sm overflow-hidden relative">
                  <div className="absolute inset-0 bg-gradient-to-r from-gray/20 via-white/10 to-gray/20 animate-shimmer"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content Skeleton */}
      <div className="padding pt-8 space-y-8">
        {/* Overview Section Skeleton */}
        <div className="space-y-3">
          <div className="h-6 md:h-8 bg-gray/30 rounded w-32 backdrop-blur-sm overflow-hidden relative">
            <div className="absolute inset-0 bg-gradient-to-r from-gray/30 via-white/10 to-gray/30 animate-shimmer"></div>
          </div>
          <div className="space-y-2 max-w-4xl">
            {[...Array(3)].map((_, i) => (
              <div key={i} className="h-4 bg-gray/20 rounded w-full backdrop-blur-sm overflow-hidden relative">
                <div className="absolute inset-0 bg-gradient-to-r from-gray/20 via-white/10 to-gray/20 animate-shimmer"></div>
              </div>
            ))}
          </div>
        </div>

        {/* Meta Info Skeleton */}
        <div className="flex flex-wrap gap-4">
          {[...Array(3)].map((_, i) => (
            <div key={i} className="h-8 bg-gray/30 rounded-lg px-4 backdrop-blur-sm overflow-hidden relative">
              <div className="absolute inset-0 bg-gradient-to-r from-gray/30 via-white/10 to-gray/30 animate-shimmer"></div>
            </div>
          ))}
        </div>

        {/* Watch Section Skeleton */}
        <div className="space-y-4">
          <div className="h-6 md:h-8 bg-gray/30 rounded w-40 backdrop-blur-sm overflow-hidden relative">
            <div className="absolute inset-0 bg-gradient-to-r from-gray/30 via-white/10 to-gray/30 animate-shimmer"></div>
          </div>
          <div className="h-10 bg-gray/20 rounded w-64 backdrop-blur-sm overflow-hidden relative">
            <div className="absolute inset-0 bg-gradient-to-r from-gray/20 via-white/10 to-gray/20 animate-shimmer"></div>
          </div>
          <div className="aspect-video rounded-lg bg-gray/20 border border-white/10 overflow-hidden relative">
            <div className="absolute inset-0 bg-gradient-to-r from-gray/30 via-white/10 to-gray/30 animate-shimmer"></div>
          </div>
        </div>

        {/* Seasons Section Skeleton */}
        <div className="space-y-4">
          <div className="h-6 md:h-8 bg-gray/30 rounded w-56 backdrop-blur-sm overflow-hidden relative">
            <div className="absolute inset-0 bg-gradient-to-r from-gray/30 via-white/10 to-gray/30 animate-shimmer"></div>
          </div>
          {[...Array(2)].map((_, i) => (
            <div key={i} className="bg-gray/10 backdrop-blur-sm rounded-lg border border-white/10 overflow-hidden">
              <div className="h-16 bg-gray/20 backdrop-blur-sm"></div>
            </div>
          ))}
        </div>

        {/* Similar Shows Section Skeleton */}
        <div className="space-y-4">
          <div className="h-6 md:h-8 bg-gray/30 rounded w-48 backdrop-blur-sm overflow-hidden relative">
            <div className="absolute inset-0 bg-gradient-to-r from-gray/30 via-white/10 to-gray/30 animate-shimmer"></div>
          </div>
          <div className="flex gap-4 overflow-hidden">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="flex-shrink-0 w-32 aspect-[2/3] rounded-lg bg-gray/20 backdrop-blur-sm overflow-hidden relative">
                <div className="absolute inset-0 bg-gradient-to-r from-gray/30 via-white/10 to-gray/30 animate-shimmer"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default EpisodePageSkeleton;

